import forge from "node-forge";

type PublicKey = forge.pki.rsa.PublicKey;
type DataToEncrypt = string;
type AesKey = string;
type InitializationVector = string;
type EncryptedData = string;

const getPublicKey = (certPem: string): PublicKey => {
  try {
    const cert = forge.pki.certificateFromPem(certPem);
    return cert.publicKey as PublicKey;
  } catch (error) {
    throw new Error("Error al obtener la llave pública");
  }
};

const encryptData = (data: DataToEncrypt, publicKey: PublicKey) => {
  try {
    const encrypted = publicKey.encrypt(data, "RSAES-PKCS1-V1_5");
    if (!encrypted) throw new Error("Falló la encriptación");
    return forge.util.encode64(encrypted);
  } catch (error) {
    throw new Error("Error al encriptar los datos: " + error.message);
  }
};

const aes256CbcEncrypt = (data: DataToEncrypt, key: AesKey, iv: InitializationVector): string => {
  try {
    const cipher = forge.cipher.createCipher("AES-CBC", key);
    cipher.start({ iv: iv });
    cipher.update(forge.util.createBuffer(data));
    const success = cipher.finish();
    if (!success) throw new Error("Falló el proceso de cifrado");
    const encrypted = cipher.output;
    return forge.util.encode64(encrypted.getBytes());
  } catch (error) {
    throw new Error("Error al cifrar con AES: " + error.message);
  }
};

const aes256CbcDecrypt = (encryptedData: EncryptedData, key: AesKey, iv: InitializationVector): string => {
  try {
    const decipher = forge.cipher.createDecipher("AES-CBC", key);
    decipher.start({ iv: iv });
    decipher.update(forge.util.createBuffer(forge.util.decode64(encryptedData)));
    const success = decipher.finish();
    if (!success) throw new Error("Falló el proceso de descifrado");
    return forge.util.decodeUtf8(decipher.output.getBytes());
  } catch (error) {
    throw new Error("Error al descifrar con AES: " + error.message);
  }
};

export { getPublicKey, encryptData, aes256CbcEncrypt, aes256CbcDecrypt };
